export default (days: string | number): string => {
  if (days || days === "0" || days === 0) {
    return `${days} Days`;
  }
  return "";
};
